import { api } from "~/shared/api"

export type UserSession = {
	ua: string;
	ip: string;
	isCurrent: boolean;
}

export async function getUserSessions() {
	const response = await api.get("/security/auth/user-sessions")
	return response.data as UserSession[]
}

export async function removeUserSession(sess: Omit<UserSession, "isCurrent">) {
	await api.delete("/security/auth/user-sessions", {
		data: sess
	})
}

export async function removeAllUserSessionsExceptCurrent() {
	await api.delete("/security/auth/user-sessions", {
		data: { excludeCurrent: true }
	})
}